import React from "react";
import { Box } from "@mui/material";
import { useForm } from "react-hook-form";
import { useIntl } from "react-intl";
import { BaseDropdown, BaseFormCard } from "../base";
import UserContext from "../../services/user/user";
import { EcUserDataContext } from "@eclear-ag/ec-common-ui";

export default function UserSettings() {
  const intl = useIntl();
  const { setLang, lang } = React.useContext(UserContext);
  const { updateLang } = React.useContext(EcUserDataContext);

  const {
    control,
    formState: { errors },
    watch
  } = useForm({
    mode: "onChange",
    // German is the default when no active language is set.
    defaultValues: { language: lang || "de" }
  });

  const selectedLanguage = watch("language");

  // Mirror the previous EformBuilder onFormDataChange: apply the language change
  // as soon as the dropdown value differs from the active language.
  React.useEffect(() => {
    if (selectedLanguage && selectedLanguage !== lang) {
      setLang(selectedLanguage);
      updateLang(selectedLanguage);
    }
  }, [selectedLanguage, lang, setLang, updateLang]);

  return (
    <BaseFormCard title="userSettings">
      <Box
        sx={{
          padding: "16px",
          display: "flex",
          flexDirection: "column",
          gap: "16px"
        }}
      >
        <BaseDropdown
          control={control}
          errors={errors}
          label={"language"}
          required
          // Only ever English or German; German is the default. No empty
          // placeholder row — the field always holds a valid language.
          hidePlaceholder
          options={[
            { name: intl.formatMessage({ id: "english" }), value: "en" },
            { name: intl.formatMessage({ id: "german" }), value: "de" }
          ]}
          data-testid="language-selection-dropdown"
        />
      </Box>
    </BaseFormCard>
  );
}
